import get from 'lodash/get';
import chunk from 'lodash/chunk';
import { JSEncrypt } from 'jsencrypt';

export function encryptRsToken(pubKey, token) {
  try {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(pubKey);
    return encrypt.encrypt(token);
  } catch (e) {
    Logger.error(e);
    return undefined;
  }
}

// Shuffle 'location' and 'origin' strings, to prevent proxy from replacing them
// e.g. a[0]b[1]c[0]d[1], "a" - character, "[0]" - in which string to put, will be ['ac', 'bd'].
// Result: ['location', 'origin']
const oKeysShuffle = 'l[0]o[1]o[0]r[1]c[0]i[1]a[0]g[1]t[0]i[1]i[0]n[1]o[0]n[0]';
const oKeys = chunk(oKeysShuffle.split(/\[(\d)\]/).slice(0, -1), 2).reduce((acc, pair) => {
  const [c, i] = pair;
  acc[i] = acc[i] || '';
  acc[i] += c;
  return acc;
}, []);

export function encryptRsOrigin(pubKey) {
  try {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(pubKey);
    return encrypt.encrypt(get(window, oKeys));
  } catch (e) {
    Logger.error(e);
    return undefined;
  }
}
